<template>
  <div>
    <div class="filters-section mb-4">
      <b-card class="">
        <b-card-header class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
              <i class="fas fa-filter mr-2"></i>Filters
          </h5>
          <div class="">
            <b-button variant="outline-primary" @click="exportReport('csv')" class="mr-2">
              <i class="fas fa-download mr-2"></i>Export CSV
            </b-button>
            <b-button variant="outline-secondary" @click="exportReport('pdf')">
              <i class="fas fa-file-pdf mr-2"></i>Export PDF
            </b-button>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="2">
              <b-form-group label="Hotel:" label-for="hotel">
                <b-form-select
                  id="hotel"
                  v-model="filters.hotel_id"
                  :options="hotelOptions"
                  @change="fetchOccupancy"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Date:" label-for="OccupancyDate">
                <b-form-datepicker 
                  :date-format-options="dateFormat"
                  id="OccupancyDate"
                  v-model="filters.date"
                  @input="fetchOccupancy"
                  label="Date:"
                  class="date-picker" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
    <div class="section">
      <h4 class="section-title"><i class="bi bi-box-arrow-in-right"></i> Occupancy</h4>
      <div v-if="!data || data.length === 0" class="text-center p-4">
        <p class="mb-0">No data found for the selected criteria.</p>
      </div>
      <b-table
        v-else
        :items="groupedReport"
        :fields="fields"
        striped hover small responsive 
        :row-class="rowClass"
        :per-page="0"
        :current-page="currentPage"
        >
        <template #cell(hotel_name) = "data">
          <template v-if="data.item.isGroupHeader">
            <strong>#{{ _.startCase(data.item.hotel_name)}}</strong>
          </template>
          <template v-else>

          </template>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="data.length"
        :per-page="perPage"
        class="mt-3"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { request } from '@/Util/Request';
export default {
  name: 'CheckInReport',
  data() {
    return {
      filters: {
        date: new Date().toISOString().slice(0, 10),
        hotel_id: null,
      },
      reportTitle:'Occupancy Report',
      perPage: 10,
      currentPage: 1,
      dateFormat: {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      },
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    hotelOptions:{
      type: Array,
      required:true
    },
    fields:{
      type: Array,
      required: true
    }
  },

  computed:{
    groupedReport() {
      let result = [];
      let hotels = {};

      if(this.data){
        const actualData  = this.data;
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        const paginatedData = actualData.slice(start, end);
        paginatedData.forEach(record => {
          const id = record.hotel_id
          if (!hotels[id]) {
            hotels[id] = [];
            result.push({ isGroupHeader: true, hotel_name: record.hotel_name }) // push group row
          }
          result.push(record)
        })
      }
      return result;
    },
  },
  methods: {
    fetchOccupancy(){
      this.$emit('get-occupancy-list',this.filters);
    },
    async exportReport(format) {
      try {
        const params = {...this.filters,format: format};
        console.log(params);
        const response = await request({
          url: `/reports/occupancy/export`,
          method: 'GET',
          params: params,
          responseType: 'blob',
        });

        const mimeType = format === 'csv' 
          ? 'text/csv' 
          : 'application/pdf';
        
        const blob = new Blob([response], { type: mimeType });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `occupancy_report.${format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$bvToast.toast(`Report exported successfully as ${format.toUpperCase()}`, {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Export failed:', error);
        this.$bvToast.toast('Error exporting report', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    rowClass(item) {
      return item.isGroupHeader ? 'table-primary' : ''
    },
    getStatusVariant(status){
      switch(status){
        case 2: return 'badge bg-success text-white';
        case 0: return 'badge bg-warning text-dark';
        case 1: return 'badge bg-secondary text-white';
      }
    }
  },
}
</script>

<style>
.filters-section {
  background: #f8fafc;
  border-radius: 8px;
}

.summary-cards {
  margin-bottom: 2rem;
}

.summary-card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  transition: transform 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
}

.summary-item {
  text-align: center;
}

.summary-item h4 {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.summary-item .amount {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.summary-item .amount.positive {
  color: #059669;
}

.summary-item .amount.negative {
  color: #dc2626;
}

.summary-item .period {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2563eb;
  margin: 0;
}

.amount.positive {
  color: #059669;
  font-weight: 600;
}

.amount.negative {
  color: #dc2626;
  font-weight: 600;
}

.percentage {
  font-weight: 600;
  color: #6b7280;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.75em;
  font-size: 0.85em;
  font-weight: 600;
  border-radius: 999px;
  text-transform: capitalize;
  letter-spacing: 0.02em;
}

.bg-success {
  background: #22c55e !important;
  color: #fff !important;
}

.bg-warning {
  background: #fbbf24 !important;
  color: #222 !important;
}

.bg-danger {
  background: #ef4444 !important;
  color: #fff !important;
}

.bg-secondary {
  background: #6b7280 !important;
  color: #fff !important;
}

.date-picker {
  min-width: 150px;
}

@media (max-width: 768px) {
  .report-title {
    font-size: 1.1rem;
  }
  
  .summary-item .amount {
    font-size: 1.25rem;
  }
}
</style>